<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let toggle_state = false;
    export let label0 = "";
    export let label1 = "";
    export let icon_0 = "";
    export let icon_1 = "";
    export let is_disabled = false;

    $: inner = toggle_state ? label1 : label0;

    function toggle() {
        if (is_disabled) {
            return;
        }
        toggle_state = !toggle_state;
    }
</script>

{#if toggle_state}
<button
    on:click={toggle}
    class="btn btn-primary {is_disabled
        ? 'disabled'
        : ''} text-button-switch btn-distance"
    >
    <i class="fa-solid {icon_1}"></i>&nbsp;&nbsp;{label1}</button
>
{:else}
<button
    on:click={toggle}
    class="btn btn-primary {is_disabled
        ? 'disabled'
        : ''} text-button-switch btn-distance"
    >
    <i class="fa-solid {icon_0}"></i>&nbsp;&nbsp;{label0}</button
>
{/if}
<button
    on:click={toggle}
    class="btn btn-primary {is_disabled
        ? 'disabled'
        : ''} icon-button-switch btn-distance"
>
    <i class="fa-solid fa-table"></i> / <i class="fa-solid fa-chart-line"></i>
</button>